import { render, staticRenderFns } from "./allUserDialog.vue?vue&type=template&id=53c20796&scoped=true&"
import script from "./allUserDialog.vue?vue&type=script&lang=js&"
export * from "./allUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./allUserDialog.vue?vue&type=style&index=0&id=53c20796&scoped=true&lang=css&"
import style1 from "./allUserDialog.vue?vue&type=style&index=1&id=53c20796&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c20796",
  null
  
)

export default component.exports